export const actionConst={
    USER_REGISTER:'USER_REGISTER',
    USER_LOGIN:'USER_LOGIN',
    USER_LOGOUT:'USER_LOGOUT'
}